import type { GameEvent, GameEventMap } from './types';

type Listener<K extends keyof GameEventMap> = (payload: GameEventMap[K]) => void;

export class TypedEventBus {
  private readonly listeners = new Map<keyof GameEventMap, Set<(payload: never) => void>>();

  on<K extends keyof GameEventMap>(type: K, listener: Listener<K>): () => void {
    const set = this.listeners.get(type) ?? new Set<(payload: never) => void>();
    set.add(listener as (payload: never) => void);
    this.listeners.set(type, set);
    return () => set.delete(listener as (payload: never) => void);
  }

  emit<K extends keyof GameEventMap>(type: K, payload: GameEventMap[K]): GameEvent {
    const event = { type, payload } as GameEvent;
    this.listeners.get(type)?.forEach((listener) => listener(payload as never));
    return event;
  }

  clear(): void {
    this.listeners.clear();
  }
}
